module.exports = __webpack_public_path__ + "img/South Africa.ea86a092.gif";